export default __webpack_public_path__ + "images/65c822ad1cf77b5ef0bdc076671d0716.svg";